import React from 'react'
import ReportWrapper from '../ReportWrapper'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import ReportSectionHeading from '../ReportSectionHeading'

interface RongdataEducationalSimpleInformationProps {
  data: any
  title: string
  sectionIndex?: string
}

const statusMap: Record<string, string> = {
  '1': '初中及以下',
  '2': '高中水平',
  '3': '专科水平',
  '4': '本科及以上',
  '0': '未知',
}

const formatEndTime = (endTime: string): string => {
  if (!endTime || endTime.length < 6) return '—'
  const year = endTime.substring(0, 4)
  const month = endTime.substring(4, 6)
  return `${year}年${month}月`
}

export default function RongdataEducationalSimpleInformation({
  data,
  title,
  sectionIndex,
}: RongdataEducationalSimpleInformationProps) {
  const theme = useTheme()

  let educationInfo: { status: string; endTime: string } = { status: '0', endTime: '' }

  try {
    const parsedData =
      typeof data.rongdata_simple_education_info === 'string'
        ? JSON.parse(data.rongdata_simple_education_info || '{}')
        : data.rongdata_simple_education_info || {}

    educationInfo = {
      status: parsedData.status || '0',
      endTime: parsedData.endTime || '',
    }
  } catch (error) {
    console.error('Failed to parse rongdata_simple_education_info:', error)
  }

  const educationLevel = statusMap[educationInfo.status] || '未知'
  const graduationTime = formatEndTime(educationInfo.endTime)

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <div className="mt-2">
        <Stack gap="md">
          <div className="flex flex-col gap-2">
            <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
              教育信息概览
            </Text>
            <Text size="xs" className="text-gray-500">
              展示全日制学历水平及毕业时间信息。
            </Text>
          </div>
          <div className="grid gap-3 md:grid-cols-2">
            <SummaryItem label="学历水平" value={educationLevel} subtitle="当前最高学历" />
            <SummaryItem label="毕业时间" value={graduationTime} subtitle="学业完成时间" />
          </div>
        </Stack>
      </div>
    </ReportWrapper>
  )
}

interface SummaryItemProps {
  label: string
  value: string
  subtitle?: string
}

function SummaryItem({ label, value, subtitle }: SummaryItemProps) {
  const theme = useTheme()

  return (
    <div
      className="rounded-lg border px-4 py-3"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Text size="xs" className="text-gray-500">
        {label}
      </Text>
      <Text size="sm" fw={600} style={{ marginTop: '6px', color: theme.primaryColor }}>
        {value}
      </Text>
      {subtitle && (
        <Text size="xs" className="text-gray-400" style={{ marginTop: '4px' }}>
          {subtitle}
        </Text>
      )}
    </div>
  )
}
